export interface Article {
  slug: string;
  title: string;
  category: string;
  description: string;
  content: string;
  coverImage: string;
  rating: number;
  year: number;
  region: string;
  tags: string[];
  episodeCount: string;
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
  director: string;
  cast: string[];
  duration: string;
  imageSeq: string;
}

export const articles: Article[] = [
  {
    slug: 'chang-feng-du',
    title: '长风渡',
    category: 'dianshiju',
    description: '白敬亭宋轶主演古装爱情剧，讲述了扬州布商之女柳玉茹与纨绔子弟顾九思从互不顺眼到相知相守的传奇故事，剧情甜虐交织令人欲罢不能。',
    content: '<h2>剧情简介</h2><p>《长风渡》改编自墨书白的同名小说，讲述了扬州布商之女柳玉茹自小遭遇生母病重、庶母不慈、父亲不重视的困境，她不得已谨小慎微，做了十五年模范闺秀。不料，对婚姻抱有憧憬的她却被家里安排嫁给了名满扬州的纨绔子弟顾九思。</p><p>顾九思误会柳玉茹是因为攀附权贵才嫁给他，对其嗤之以鼻。柳玉茹幡然醒悟，不能将命运系之婚姻，系之他人，决定跟随顾母学习经商之道。经过一系列波折，两人从最初的互不顺眼到逐渐理解、相知相爱，共同经历了家族兴衰、朝堂动荡，最终成为彼此的依靠。</p><h2>精彩看点</h2><p>白敬亭与宋轶的精彩演绎让顾九思和柳玉茹这对欢喜冤家深入人心。剧中不仅有甜蜜的爱情线，更有女性成长的励志故事。精美的服化道和场景布置也让观众大饱眼福。</p>',
    coverImage: '',
    rating: 8.5,
    year: 2023,
    region: '中国大陆',
    tags: ['古装', '爱情', '励志'],
    episodeCount: '40集全',
    updateDate: '2024-07-28',
    isHot: true,
    isNew: false,
    director: '尹涛',
    cast: ['白敬亭', '宋轶', '刘学义', '张昊唯'],
    duration: '45分钟/集',
    imageSeq: 'article-changfengdu',
  },
  {
    slug: 'kuang-biao',
    title: '狂飙',
    category: 'dianshiju',
    description: '张译张颂文主演年度现象级扫黑剧，讲述了一线刑警安欣与黑恶势力长达二十年的生死搏斗，剧情紧凑演技炸裂被誉为国产剧天花板。',
    content: '<h2>剧情简介</h2><p>《狂飙》讲述了以一线刑警安欣为代表的正义力量，与黑恶势力展开的长达二十年的生死搏斗故事。通过群像叙事，展现扫黑行动中的黑白较量和复杂人性。</p><p>故事横跨二十年，从2000年开始，安欣作为一名年轻刑警，在黑恶势力猖獗的环境中坚守正义。高启强从一个普通鱼贩逐渐堕落为黑恶势力头目，两人之间的对抗贯穿全剧。剧集深入刻画了人物成长与转变的轨迹，展现了扫黑除恶斗争的艰巨与复杂。</p><h2>精彩看点</h2><p>张译和张颂文的对手戏堪称教科书级别。高启强从底层小人物的挣扎到黑化全过程令人唏嘘。剧中对人性的刻画深刻入骨，每个配角都有血有肉。</p>',
    coverImage: '',
    rating: 9.1,
    year: 2023,
    region: '中国大陆',
    tags: ['刑侦', '悬疑', '剧情'],
    episodeCount: '39集全',
    updateDate: '2024-07-26',
    isHot: true,
    isNew: false,
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    duration: '45分钟/集',
    imageSeq: 'article-kuangbiao',
  },
  {
    slug: 'lang-ya-bang-zhi-feng-qi-chang-lin',
    title: '琅琊榜之风起长林',
    category: 'dianshiju',
    description: '黄晓明刘昊然主演古装权谋大剧，长林王府忠肝义胆保家卫国，家国情怀与权谋斗争交织，延续琅琊榜经典IP的辉煌。',
    content: '<h2>剧情简介</h2><p>大梁朝局安稳，但边境战火不断，守护大梁北境的长林军屡获军功。长林王萧庭生忠君爱国，其子萧平章和萧平旌皆为军中栋梁。然而朝堂之上，皇后与内阁首辅荀白水对长林王府的势力忌惮不已，暗中设计陷害。</p><p>萧平章战死沙场后，萧平旌继承兄长遗志，率领长林军继续守护大梁。在一系列阴谋与斗争中，萧平旌逐渐成长，最终揭开了隐藏在朝堂深处的巨大秘密。</p><h2>精彩看点</h2><p>作为《琅琊榜》的续作，本剧延续了精良的制作水准。黄晓明的萧平章沉稳大气，刘昊然的萧平旌少年意气，两人的兄弟情令人动容。家国天下的宏大主题与精妙的权谋布局相得益彰。</p>',
    coverImage: '',
    rating: 8.3,
    year: 2017,
    region: '中国大陆',
    tags: ['古装', '权谋', '战争'],
    episodeCount: '50集全',
    updateDate: '2024-07-25',
    isHot: false,
    isNew: false,
    director: '孔笙',
    cast: ['黄晓明', '刘昊然', '佟丽娅', '张慧雯'],
    duration: '45分钟/集',
    imageSeq: 'article-langyabang2',
  },
  {
    slug: 'liu-lang-di-qiu-2',
    title: '流浪地球2',
    category: 'dianying',
    description: '吴京刘德华主演国产科幻巨制，太阳即将毁灭人类开启流浪地球计划，视觉特效震撼人心被誉为中国科幻电影新里程碑。',
    content: '<h2>剧情简介</h2><p>《流浪地球2》是《流浪地球》的前传，讲述了太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。</p><p>影片以三个主要故事线展开：刘培强成为宇航员的成长历程、图恒宇与数字生命计划的纠葛、以及周喆直与联合政府的危机应对。三条线索交织推进，共同构成了这场关乎人类命运的宏大叙事。</p><h2>精彩看点</h2><p>影片视觉效果达到国际一流水平，太空电梯、月球危机等场景震撼至极。吴京与刘德华的表演为这部科幻巨制注入了深厚的情感内核。\"五十岁以上出列\"的桥段让无数观众泪目。</p>',
    coverImage: '',
    rating: 8.7,
    year: 2023,
    region: '中国大陆',
    tags: ['科幻', '灾难', '冒险'],
    episodeCount: '173分钟',
    updateDate: '2024-07-28',
    isHot: true,
    isNew: false,
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢'],
    duration: '173分钟',
    imageSeq: 'article-liulangdiqiu2',
  },
  {
    slug: 'man-jiang-hong',
    title: '满江红',
    category: 'dianying',
    description: '张艺谋执导沈腾易烊千玺主演悬疑喜剧，南宋绍兴年间一场围绕秦桧的惊天阴谋层层反转，笑中带泪结局震撼。',
    content: '<h2>剧情简介</h2><p>南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这巨大阴谋之中，宰相秦桧命两人限一个时辰之内找到凶手。</p><p>伴随危机四伏的深入调查，宰相府总管何立、副总管武义淳、舞姬瑶琴等人卷入局中，案件的背后似乎隐藏着一场更大的阴谋。局中有局、人心叵测，一夜之间风云变幻，各方势力暗流涌动。</p><h2>精彩看点</h2><p>张艺谋将悬疑与喜剧元素巧妙融合，沈腾的表演收放自如。全片在一个封闭空间内展开，节奏紧凑环环相扣。最后的反转令人拍案叫绝，\"满江红\"的呈现方式震撼人心。</p>',
    coverImage: '',
    rating: 7.8,
    year: 2023,
    region: '中国大陆',
    tags: ['悬疑', '喜剧', '历史'],
    episodeCount: '159分钟',
    updateDate: '2024-07-27',
    isHot: true,
    isNew: false,
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    duration: '159分钟',
    imageSeq: 'article-manjianghong',
  },
  {
    slug: 'gu-zhu-yi-zhi',
    title: '孤注一掷',
    category: 'dianying',
    description: '张艺兴金晨主演反诈题材电影，揭秘境外网络诈骗全产业链，程序员模特被骗至海外诈骗工厂的惊险逃生故事。',
    content: '<h2>剧情简介</h2><p>程序员潘生和模特安娜被海外高薪招聘吸引，出国淘金却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现完成业绩。</p><p>潘生与安娜能否逃过诈骗集团头目陆经理和阿才的残暴折磨？面对警察的跨国调查和追捕，他们又将何去何从？影片改编自上万起真实诈骗案例，揭示了境外网络诈骗的骇人内幕。</p><h2>精彩看点</h2><p>影片真实还原了境外诈骗工厂的运作模式，令人触目惊心。张艺兴突破偶像形象，演绎技术宅的绝望与挣扎。王传君饰演的诈骗头目令人不寒而栗，贡献了教科书级别的反派表演。</p>',
    coverImage: '',
    rating: 8.2,
    year: 2023,
    region: '中国大陆',
    tags: ['犯罪', '剧情', '社会'],
    episodeCount: '130分钟',
    updateDate: '2024-07-26',
    isHot: false,
    isNew: true,
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君'],
    duration: '130分钟',
    imageSeq: 'article-guzhuyizhi',
  },
  {
    slug: 'feng-shen-di-yi-bu',
    title: '封神第一部：朝歌风云',
    category: 'dianying',
    description: '乌尔善执导费翔李雪健主演史诗神话大片，商王殷寿暴虐无道引发天谴，姬发觉醒踏上封神之路视觉效果炸裂。',
    content: '<h2>剧情简介</h2><p>商王殷寿与狐妖妲己勾结，暴虐无道引发天谴。昆仑仙人姜子牙携\"封神榜\"下山，寻找天下共主以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。</p><p>各方势力暗流涌动，风云变幻端倪初显。殷寿的野心、妲己的魅惑、姬发的觉醒、姜子牙的谋划，共同编织了一幅波澜壮阔的史诗画卷。三千年想象已成真，恢弘史诗再创新。</p><h2>精彩看点</h2><p>费翔的殷寿霸气十足，质子旅的设定新颖出彩。影片在尊重原著的基础上进行了大胆创新，视觉效果和动作场面堪称国产电影新标杆。片尾彩蛋更是让人对第二部充满期待。</p>',
    coverImage: '',
    rating: 8.0,
    year: 2023,
    region: '中国大陆',
    tags: ['神话', '史诗', '奇幻'],
    episodeCount: '148分钟',
    updateDate: '2024-07-24',
    isHot: false,
    isNew: true,
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适'],
    duration: '148分钟',
    imageSeq: 'article-fengshen1',
  },
  {
    slug: 'cheng-feng-po-lang-2024',
    title: '乘风破浪2024',
    category: 'zongyi',
    description: '热门女团成长综艺最新季，多位实力女艺人齐聚舞台竞演，突破自我挑战唱跳极限，姐姐们的魅力势不可挡。',
    content: '<h2>节目简介</h2><p>《乘风破浪2024》是芒果TV推出的女团成长综艺节目。节目集结了多位来自不同领域的女性艺人，她们将通过舞台竞演、团队合作等方式，突破自我、挑战极限，最终成团出道。</p><p>本季节目在赛制上进行了全面升级，引入了更多元的考核标准和更具挑战性的舞台任务。姐姐们需要在歌唱、舞蹈、创作等多个维度上不断突破，展现当代女性的多元魅力与无限可能。</p><h2>精彩看点</h2><p>豪华的阵容配置让本季节目看点十足。姐姐们在训练中的努力与坚持、舞台上的惊艳表现、以及宿舍生活中的真情流露，共同构成了这档现象级综艺的独特魅力。</p>',
    coverImage: '',
    rating: 8.1,
    year: 2024,
    region: '中国大陆',
    tags: ['音乐', '竞演', '女性'],
    episodeCount: '更新至第8期',
    updateDate: '2024-07-28',
    isHot: true,
    isNew: true,
    director: '芒果TV',
    cast: ['多位女艺人'],
    duration: '120分钟/期',
    imageSeq: 'article-chengfengpolang',
  },
  {
    slug: 'tuo-kou-xiu-da-hui-5',
    title: '脱口秀大会第五季',
    category: 'zongyi',
    description: '现象级脱口秀竞演节目，新老脱口秀演员同台竞技金句频出，搞笑与犀利并存让你笑到停不下来。',
    content: '<h2>节目简介</h2><p>《脱口秀大会》是由腾讯视频出品的一档脱口秀竞技节目。每季节目汇集众多脱口秀演员，通过多轮竞演，最终角逐年度\"脱口秀大王\"的称号。</p><p>第五季节目在选手阵容和赛制上都进行了升级，不仅有老将回归，更有新人黑马涌现。选手们通过幽默犀利的表达，讲述生活中的酸甜苦辣，引发观众强烈共鸣。</p><h2>精彩看点</h2><p>老选手的成熟稳健与新选手的锋芒毕露形成鲜明对比。每期的主题设置紧贴社会热点，段子既有笑点又有深度。领笑员的犀利点评也为节目增色不少。</p>',
    coverImage: '',
    rating: 7.9,
    year: 2023,
    region: '中国大陆',
    tags: ['脱口秀', '喜剧', '语言'],
    episodeCount: '10期全',
    updateDate: '2024-07-23',
    isHot: false,
    isNew: false,
    director: '腾讯视频',
    cast: ['多位脱口秀演员'],
    duration: '90分钟/期',
    imageSeq: 'article-tuokouxiu',
  },
  {
    slug: 'beng-huai-xing-qiong-tie-dao',
    title: '崩坏：星穹铁道',
    category: 'dongman',
    description: '米哈游出品科幻冒险动画，开拓者乘坐星穹列车穿梭于银河之间，探索未知星球邂逅伙伴精彩冒险。',
    content: '<h2>剧情简介</h2><p>《崩坏：星穹铁道》讲述了开拓者乘坐星穹列车，穿梭于银河之间的冒险故事。在旅途中，开拓者将邂逅性格各异的伙伴，共同面对来自「星核」的危机，揭开隐藏在银河深处的秘密。</p><p>列车途径的每一个星球都有独特的世界观和故事线：冰雪覆盖的雅利洛-VI、充满东方韵味的仙舟「罗浮」、赛博朋克风格的匹诺康尼……每一次停靠都是一段崭新的冒险。</p><h2>精彩看点</h2><p>精美的作画质量和豪华的声优阵容让这部动画达到了国际一流水准。剧情张弛有度，既有轻松搞笑的日常，也有催人泪下的感人篇章。世界观设定宏大而精密，引人入胜。</p>',
    coverImage: '',
    rating: 9.0,
    year: 2023,
    region: '中国',
    tags: ['科幻', '冒险', '奇幻'],
    episodeCount: '更新至第42集',
    updateDate: '2024-07-28',
    isHot: true,
    isNew: true,
    director: '米哈游',
    cast: ['多位声优'],
    duration: '24分钟/集',
    imageSeq: 'article-benghuai',
  },
  {
    slug: 'dou-luo-da-lu',
    title: '斗罗大陆',
    category: 'dongman',
    description: '唐家三少经典小说改编国漫巅峰之作，唐三穿越斗罗大陆觉醒双武魂踏上成神之路，热血战斗场面燃爆。',
    content: '<h2>剧情简介</h2><p>唐门外门弟子唐三，因偷学内门绝学被长老们追杀后跳崖明志，却意外穿越到斗罗大陆。在这片武魂的世界里，唐三觉醒双武魂，进入史莱克学院学习，结识了一群生死与共的伙伴。</p><p>从魂师到魂王，从封号斗罗到海神神位，唐三一路成长、一路突破。在与武魂殿的斗争中，唐三带领史莱克七怪守护正义，最终踏上成神之路。</p><h2>精彩看点</h2><p>作为国漫的代表作之一，动画在画面质量上不断突破。热血沸腾的战斗场面、感人至深的友情羁绊、环环相扣的剧情推进，让这部作品成为无数观众的童年回忆和青春印记。</p>',
    coverImage: '',
    rating: 8.8,
    year: 2018,
    region: '中国',
    tags: ['热血', '奇幻', '战斗'],
    episodeCount: '更新至第287集',
    updateDate: '2024-07-27',
    isHot: true,
    isNew: false,
    director: '玄机科技',
    cast: ['多位声优'],
    duration: '20分钟/集',
    imageSeq: 'article-douluodalu',
  },
  {
    slug: 'zhu-xian',
    title: '诛仙',
    category: 'dongman',
    description: '萧鼎经典仙侠小说改编动画，张小凡从一个平凡少年成长为绝世强者，正邪之争与爱恨纠葛令人唏嘘。',
    content: '<h2>剧情简介</h2><p>《诛仙》讲述了草庙村少年张小凡，在经历屠村惨案后，被青云门收为弟子。他天资愚钝却勤奋刻苦，在修行的道路上一路成长，逐渐揭开了当年屠村惨案背后的惊天秘密。</p><p>张小凡在青云门中结识了林惊羽、陆雪琪等好友，经历了七脉会武、空桑山万蝠古窟、流波山之战等重大事件。正邪之间的较量、爱恨交织的情感、以及对天道的追寻，构成了这部仙侠史诗的核心。</p><h2>精彩看点</h2><p>动画忠实还原了原著小说的经典情节，画面的唯美程度令人赞叹。张小凡的成长历程充满波折，从天资平庸到最终成就非凡，这个故事激励着每一个普通人的不凡梦想。</p>',
    coverImage: '',
    rating: 8.4,
    year: 2022,
    region: '中国',
    tags: ['仙侠', '奇幻', '爱情'],
    episodeCount: '更新至第36集',
    updateDate: '2024-07-25',
    isHot: false,
    isNew: true,
    director: '云图动漫',
    cast: ['多位声优'],
    duration: '22分钟/集',
    imageSeq: 'article-zhuxian',
  },
  {
    slug: 'she-jian-shang-de-zhong-guo-4',
    title: '舌尖上的中国第四季',
    category: 'jilupian',
    description: '经典美食纪录片最新季，深入中国各地探寻最地道的风味美食，每一帧都让人垂涎欲滴感受中华饮食文化博大精深。',
    content: '<h2>内容简介</h2><p>《舌尖上的中国》第四季延续了前作的精良制作，继续深入中国各地的山川湖海、城镇乡野，探寻那些令人难忘的中华美食。从东北的炖菜到广东的早茶，从西北的面食到江南的水产，每一道美食背后都有着动人的故事。</p><p>本季在选题上更加注重人与食物之间的关系，不仅展现美食的制作过程，更深入挖掘食物背后的文化传承、情感寄托和时代变迁。每一集都像一封写给中华饮食文化的情书。</p><h2>精彩看点</h2><p>精美的画面质感和富有诗意的旁白依然是本系列的最大特色。第四季在拍摄手法上有了新的突破，微观摄影和延时摄影的运用让食物的美感被展现得淋漓尽致。</p>',
    coverImage: '',
    rating: 9.2,
    year: 2024,
    region: '中国大陆',
    tags: ['美食', '文化', '人文'],
    episodeCount: '更新至第5集',
    updateDate: '2024-07-28',
    isHot: true,
    isNew: true,
    director: '陈晓卿',
    cast: ['多位受访者'],
    duration: '50分钟/集',
    imageSeq: 'article-shejianshangdezhongguo',
  },
  {
    slug: 'lan-se-xing-qiu-2',
    title: '蓝色星球2',
    category: 'jilupian',
    description: 'BBC出品海洋纪录片巅峰之作，4K超高清拍摄揭示深海世界的奇幻奥秘，从北极到南极壮丽海洋奇观尽收眼底。',
    content: '<h2>内容简介</h2><p>《蓝色星球2》历时4年拍摄，访问了39个国家，进行了125次探险，在水下拍摄超过6000小时。这部纪录片以前所未有的方式揭示了海洋世界的奇幻与壮丽。</p><p>从北极的冰下世界到珊瑚礁的五彩斑斓，从深海的热液喷口到开阔海域的壮阔迁徙，每一集都展示了海洋生态系统的惊人多样性和精妙平衡。大卫·爱登堡爵士的解说为这部视觉盛宴增添了灵魂。</p><h2>精彩看点</h2><p>影片采用最先进的4K超高清拍摄技术，捕捉到了许多前所未见的海洋生物行为。猪齿鱼使用工具、章鱼与鲨鱼的对决等经典片段令人叹为观止。配乐由汉斯·季默操刀，大气磅礴。</p>',
    coverImage: '',
    rating: 9.8,
    year: 2017,
    region: '英国',
    tags: ['自然', '海洋', '动物'],
    episodeCount: '7集全',
    updateDate: '2024-07-22',
    isHot: false,
    isNew: false,
    director: 'BBC',
    cast: ['大卫·爱登堡'],
    duration: '60分钟/集',
    imageSeq: 'article-lansexingqiu',
  },
  {
    slug: 'he-xi-zou-lang',
    title: '河西走廊',
    category: 'jilupian',
    description: '央视出品大型历史纪录片，以河西走廊为线索讲述两千年来中国西部的兴衰变迁，气势恢宏的历史画卷令人震撼。',
    content: '<h2>内容简介</h2><p>《河西走廊》以位于中国西部的重要通道——河西走廊为讲述对象，从政治、军事、经济、文化、宗教等多角度呈现了从汉代开始直至今天，河西走廊及其连接的中国西部的历史。</p><p>全片共十集，以时间为线索，梳理了河西走廊两千多年的历史变迁。从张骞出使西域到丝绸之路的繁荣，从佛教东传到西部大开发，每一集都是一段荡气回肠的历史篇章。</p><h2>精彩看点</h2><p>影片采用情景再现与实景拍摄相结合的方式，画面质感极佳。恢弘的配乐和深情的旁白相得益彰，让观众仿佛穿越时空，亲历那段波澜壮阔的历史。豆瓣评分高达9.7分，是国产纪录片的标杆之作。</p>',
    coverImage: '',
    rating: 9.7,
    year: 2015,
    region: '中国大陆',
    tags: ['历史', '文化', '地理'],
    episodeCount: '10集全',
    updateDate: '2024-07-20',
    isHot: false,
    isNew: false,
    director: '央视纪录频道',
    cast: ['多位学者'],
    duration: '50分钟/集',
    imageSeq: 'article-hexizoulang',
  },
  {
    slug: 'san-ti',
    title: '三体',
    category: 'dianshiju',
    description: '刘慈欣雨果奖科幻巨著改编电视剧，纳米科学家汪淼卷入三体游戏探寻外星文明真相，硬核科幻引爆全网热议。',
    content: '<h2>剧情简介</h2><p>《三体》改编自刘慈欣的同名科幻小说。故事讲述了纳米科学家汪淼被警官史强带到联合作战中心，潜入神秘组织\"科学边界\"协助调查。在调查中，汪淼接触到一个名为《三体》的虚拟现实游戏，游戏中一个即将毁灭的文明正在寻找新的家园。</p><p>随着调查的深入，汪淼发现地球基础科学出现了异常的扰动，一系列科学家自杀事件背后隐藏着惊天秘密。外星文明\"三体\"的存在逐渐浮出水面，人类文明面临前所未有的危机。</p><h2>精彩看点</h2><p>剧集忠实还原了原著小说的硬核科学设定和宏大世界观。\"古筝行动\"等经典场景的视觉呈现震撼人心。张鲁一和于和伟的精湛演技让汪淼和史强这两个角色鲜活立体。</p>',
    coverImage: '',
    rating: 8.6,
    year: 2023,
    region: '中国大陆',
    tags: ['科幻', '悬疑', '剧情'],
    episodeCount: '30集全',
    updateDate: '2024-07-21',
    isHot: false,
    isNew: false,
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    duration: '45分钟/集',
    imageSeq: 'article-santi',
  },
  {
    slug: 'qing-yu-nian-2',
    title: '庆余年2',
    category: 'dianshiju',
    description: '张若昀领衔古装权谋大剧续作，范闲从北齐归来重返京都朝堂风云再起，新老角色齐聚看点加倍。',
    content: '<h2>剧情简介</h2><p>《庆余年》第二季延续第一季的故事线，范闲从北齐归来后，面对更加复杂的朝堂局势。庆帝的猜忌、太子的野心、二皇子的谋略，各方势力在京都暗流涌动。</p><p>范闲在权谋的漩涡中不断成长，同时也在追寻自己身世的真相。他与林婉儿的感情线也迎来了新的发展。更多原著中的经典角色将在本季登场，为故事注入新的活力。</p><h2>精彩看点</h2><p>张若昀的范闲依然是最大看点，机智幽默中不失深沉。第二季在制作上全面升级，服化道更为精致。新加入的演员阵容强大，为剧集增添了更多看点。权谋与喜剧的平衡拿捏得当。</p>',
    coverImage: '',
    rating: 8.4,
    year: 2024,
    region: '中国大陆',
    tags: ['古装', '权谋', '喜剧'],
    episodeCount: '36集全',
    updateDate: '2024-07-28',
    isHot: true,
    isNew: true,
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    duration: '45分钟/集',
    imageSeq: 'article-qingyunian2',
  },
  {
    slug: 'xiao-shi-de-ta',
    title: '消失的她',
    category: 'dianying',
    description: '朱一龙倪妮主演悬疑犯罪片，丈夫报警妻子失踪却牵出惊天骗局，层层反转不到最后一秒猜不到真相。',
    content: '<h2>剧情简介</h2><p>何非的妻子李木子在结婚周年旅行中离奇消失。当何非苦寻无果之时，妻子再次现身，何非却坚持眼前的陌生女人并非妻子。夫妻二人似乎都有不可告人的秘密。</p><p>随着金牌律师陈麦介入这起离奇案件，更多的谜团浮出水面。每个人都在这场精心设计的骗局中扮演着各自的角色，真相远比想象中更加令人震惊。</p><h2>精彩看点</h2><p>朱一龙贡献了从影以来最具突破性的表演，将一个复杂多面的角色演绎得入木三分。剧情的多次反转设计精巧，直到最后一刻都在挑战观众的推理能力。倪妮饰演的金牌律师气场全开。</p>',
    coverImage: '',
    rating: 7.5,
    year: 2023,
    region: '中国大陆',
    tags: ['悬疑', '犯罪', '剧情'],
    episodeCount: '122分钟',
    updateDate: '2024-07-18',
    isHot: false,
    isNew: false,
    director: '崔睿',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    duration: '122分钟',
    imageSeq: 'article-xiaoshideta',
  },
  {
    slug: 'xi-huan-ni',
    title: '喜欢你我也是',
    category: 'zongyi',
    description: '素人恋爱观察综艺甜蜜回归，男女嘉宾同住心动小屋展开浪漫约会，甜蜜互动让观察团姨母笑不停。',
    content: '<h2>节目简介</h2><p>《喜欢你我也是》是一档青年社交观察综艺。节目邀请多位素人单身男女入住\"喜欢你小屋\"，在为期一个月的时间里共同生活，通过各种约会和互动寻找心仪的另一半。</p><p>明星观察团在演播室实时观察素人嘉宾的互动，分析他们的情感走向。节目不设剧本，真实记录当代年轻人的恋爱观和社交方式。</p><h2>精彩看点</h2><p>素人嘉宾的真诚互动是节目的最大看点。从初识的羞涩到逐渐熟悉后的默契，每一个心动瞬间都让人沉浸其中。观察团的\"神预测\"和\"打脸现场\"也为节目增添了不少欢乐。</p>',
    coverImage: '',
    rating: 7.6,
    year: 2024,
    region: '中国大陆',
    tags: ['恋爱', '观察', '真人秀'],
    episodeCount: '更新至第6期',
    updateDate: '2024-07-27',
    isHot: false,
    isNew: true,
    director: '爱奇艺',
    cast: ['多位素人嘉宾'],
    duration: '90分钟/期',
    imageSeq: 'article-xihuanni',
  },
  {
    slug: 'quan-zhi-gao-shou',
    title: '全职高手',
    category: 'dongman',
    description: '蝴蝶蓝经典电竞小说改编动画，叶修被俱乐部驱逐后重新组建战队重返荣耀巅峰，热血电竞青春不散场。',
    content: '<h2>剧情简介</h2><p>被誉为\"荣耀教科书\"的顶尖高手叶修，遭到俱乐部驱逐后，栖身于一家网吧成了夜间网管。但他拥有十年游戏经验，在荣耀新开的第十区重新投入游戏，带着对往昔的回忆和一把未完成的自制银武，开始了重返巅峰之路。</p><p>从单枪匹马到组建兴欣战队，叶修带领一群志同道合的伙伴在职业联盟中掀起一场青春风暴。他们用实力证明了：荣耀，从来不是一个人的游戏。</p><h2>精彩看点</h2><p>动画在游戏战斗场景的呈现上极为出色，每一场对决都让人热血沸腾。叶修从低谷中重新崛起的励志故事感染了无数观众。配音阵容豪华，角色塑造深入人心。</p>',
    coverImage: '',
    rating: 8.7,
    year: 2017,
    region: '中国',
    tags: ['电竞', '热血', '励志'],
    episodeCount: '12集全+特别篇',
    updateDate: '2024-07-19',
    isHot: false,
    isNew: false,
    director: '视美经典',
    cast: ['多位声优'],
    duration: '24分钟/集',
    imageSeq: 'article-quanzhigaoshou',
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  if (categorySlug === 'all') return articles;
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getHotArticles = (limit: number = 6): Article[] => {
  return articles.filter((a) => a.isHot).slice(0, limit);
};

export const getNewArticles = (limit: number = 8): Article[] => {
  return articles
    .filter((a) => a.isNew)
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, limit);
};

export const getRelatedArticles = (currentSlug: string, category: string, limit: number = 4): Article[] => {
  return articles
    .filter((a) => a.category === category && a.slug !== currentSlug)
    .slice(0, limit);
};